module.exports = __webpack_public_path__ + "static/media/ic_co_browse_activate.e72c8fb6.svg";